


































































































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ReportIPIPMRow } from "../table-data/ReportIPIPMRow"
import { Classificator } from "../../../common/types/Classificator"
import { Indicator } from "../../../common/types/Indicator"
import {BudgetType, Segmentation} from "../../../common/types/roots/fields"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { cloneDeep } from "lodash"
import popUp from '../../../tabs/constructor/components/popUp.vue'
import {Draggable} from "@/modules/budget/monitoring/reports-constructor/common/types/Draggable";

type Column = keyof ReportIPIPMRow

interface TableField {
    key: string
    active: boolean
    label: string | null
    colspan: number
    child_list: TableField[]
    rowspan: number
    is_parent: boolean
    color: string
}
const HEADERS_DICT = {
    "name": null,
    "expert_cost": null,
    "impl_period": null,
    "suplier_name": null,
    "suplier_bin": null,
    "contractnumbersys_0": "contractnumbersys",
    "contractnumbersys_1": "contractnumbersys",
    "contract_sum_0": null,
    "contract_sum_1": null,
    "amount_this_year": null,
    "history": "history_header",
    "history_rb": "history_header",
    "history_nf": "history_header",
    "history_ob": "history_header",
    "history_mb": "history_header",
    "history_vz": "history_header",
    "history_br": "history_header",
    "plan": "plan_header",
    "plan_rb": "plan_header",
    "plan_nf": "plan_header",
    "plan_ob": "plan_header",
    "plan_mb": "plan_header",
    "plan_vz": "plan_header",
    "plan_br": "plan_header",
    "fact": "fact_header",
    "fact_rb": "fact_header",
    "fact_nf": "fact_header",
    "fact_ob": "fact_header",
    "fact_mb": "fact_header",
    "fact_vz": "fact_header",
    "fact_br": "fact_header",
    "remain_plan": "remain_plan_header",
    "remain_plan_rb": "remain_plan_header",
    "remain_plan_nf": "remain_plan_header",
    "remain_plan_ob": "remain_plan_header",
    "remain_plan_mb": "remain_plan_header",
    "remain_plan_vz": "remain_plan_header",
    "remain_plan_br": "remain_plan_header",
    "remain_dog": "remain_dog_header",
    "remain_dog_total": "remain_dog_header",
    "report_number": null,
    "montaj_act": null,
    "comment": null
}
const LABEL_MAP: Record<string, string> = {
    rb: '011',
    nf: '032',
    ob: '028',
    mb: '015',
    vz: '005',
    br: '029',
}
const HEADER_COLORS: Record<string, string> = {
    history_header: '#B7DEE8',
    plan_header: '#FCD5B4',
    fact_header: '#ABBC87',
    remain_plan_header: '#F2DCDB',
    remain_dog_header: '#F2DCDB',
    report_number: '#D9D9D9',
    montaj_act: '#D9D9D9',
    comment: '#D9D9D9',
}

const DEFAULT_COLOR = '#DDD9C4'
@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading,
        'pop-up': popUp,
    }
})
export default class ReportIPIPM extends Vue {

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    public readonly tableData!: ReportIPIPMRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propIndicators!: Indicator[]
    @Prop({
        type: Date,
        required: true,
        default: new Date(),
    })
    private readonly periodTo!: Date
    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]
    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly segmentation!: Draggable<Segmentation>[]

    public classifications: Classificator[] = []
    public tableFields: TableField[] = []
    public indicators: Indicator[] = []

    public currentPage = 1
    public perPage = 500
    public get visibleRows() {
        return this.tableData.filter(it => it.visible).length
    }
    public get currentItems(): ReportIPIPMRow[] {
        const indexedPage = this.currentPage - 1
        const startIndex = indexedPage * this.perPage
        const endIndex = startIndex + this.perPage
        return this.tableData.filter(it => it.visible).slice(startIndex, endIndex)
    }

    private created() {
        this.indicators = cloneDeep(this.propIndicators)
        this.constructTableFields(true)
        this.tableCollapse = true
        this.handlePageChange(1)
    }


    private makeChild(key: string, color: string): TableField {
        const suffix = Object.keys(LABEL_MAP).find(s => key.endsWith(s))
        if (suffix) {
            const lowChild: TableField = {
                key: key,
                label: LABEL_MAP[suffix],
                active: true,
                is_parent: false,
                child_list: [],
                colspan: 1,
                rowspan: 2,
                color: color
            }
            return {
                key: key,
                label: null,
                active: true,
                is_parent: true,
                child_list: [lowChild],
                colspan: 1,
                rowspan: 1,
                color: color
            }
        }
        return {
            key: key,
            label: null,
            active: true,
            is_parent: false,
            child_list: [],
            colspan: 1,
            rowspan: 2,
            color: color
        }
    }
    private constructTableFields(isOnCreate: boolean) {
        let totalClassifications: Classificator[] = []
        const classifications = cloneDeep(this.expenses)
        this.segmentation.forEach((seg) => {
            if (seg.active) {
                if (seg.value === 'REGION') {
                    totalClassifications.push({
                        key: 'region',
                        active: true,
                        selected: []
                    })
                } else if (seg.value === 'KBK') {
                    totalClassifications = [...totalClassifications, ...classifications]
                }
            }
        })
        const activeClassifications = totalClassifications.filter(it => it.active)
        this.classifications = activeClassifications
        const order = cloneDeep(isOnCreate ? this.propIndicators : this.indicators).filter(it => it.active).map(indicator => indicator.key)
        const tree: TableField[] = []
        const indexMap: Record<string, number> = {}

        for (const i of order) {
            const parentKey = HEADERS_DICT[i as keyof typeof HEADERS_DICT] ?? null
            let color = DEFAULT_COLOR
            if (parentKey) {
                color = HEADER_COLORS[parentKey] ?? DEFAULT_COLOR
            } else {
                color = HEADER_COLORS[i] ?? DEFAULT_COLOR
            }
            if (parentKey) {
                if (!(parentKey in indexMap)) {
                    const node: TableField = {
                        key: parentKey,
                        label: null,
                        active: true,
                        is_parent: true,
                        child_list: [this.makeChild(i, color)],
                        colspan: 1,
                        rowspan: 1,
                        color: color,
                    }
                    indexMap[parentKey] = tree.length
                    tree.push(node)
                } else {
                    const node = tree[indexMap[parentKey]]
                    node.child_list.push(this.makeChild(i, color))
                    node.colspan += 1
                }
            } else {
                tree.push({
                    key: i,
                    label: null,
                    active: true,
                    is_parent: false,
                    child_list: [],
                    colspan: 1,
                    rowspan: 3,
                    color: color,
                })
            }
        }
        this.tableFields = tree
    }

    public handlePageChange(page: number) {
        this.currentPage = page
    }

    public tr(key: any): string | null {
        if (typeof key !== 'string') {
            return null
        }

        let text = ''
        let tableTranslationKey = ''
        tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.ipipm'
        text = String(this.$t(`${tableTranslationKey}.${key}`))

        if (!text || text === `${tableTranslationKey}.${key}`) {

            const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
            text = String(this.$t(`${translationKey}.${key}`))

            if (!text || text === `${translationKey}.${key}`) {
                text = key
            }
        }
        if (text.includes('$year2')) {
            text = text.replace('$year2', this.periodTo.getFullYear().toString())
        }
        if (text.includes('$year')) {
            const year = this.periodTo.getFullYear()
            text = text.replace('$year', year.toString())
        }
        return text
    }

    public synchronizeIndicatorsOrder() {
        // const fullIndicatorKeys = this.indicatorKeys.filter(it => ['plgp', 'plgo'].notIncludes(it)).concat(['plgs'])
        // const indicatorsOrder = this.tableFields
        //     .filter(it => fullIndicatorKeys.includes(it.key))
        //     .map(it => it.key)

        //     fullIndicatorKeys.forEach(indicatorKey => {
        //     if (indicatorsOrder.notIncludes(indicatorKey)) {
        //         indicatorsOrder.push(indicatorKey)
        //     }
        // })

        // const tempIndicators: Indicator[] = []
        // indicatorsOrder.forEach(indicatorKey => {
        //     const IndicatorObject = this.indicators.find(it => it.key === indicatorKey)!
        //     tempIndicators.push(IndicatorObject)
        // })

        // this.indicators = tempIndicators
        // this.$emit('update-indicators', tempIndicators)
    }
    public get getTableFields(): TableField[] {
        return this.tableFields.flatMap(column =>
            column.is_parent ? column.child_list : [column]
        )
    }

    public synchronizeVisiblityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.constructTableFields(false)
    }

    public format(value: any): any {
        if (value == null) {
            return ''
        }
        if (typeof value === 'string') {
            return value
        }
        if (Number(value).isNaN) {
            return value
        }
        return formatDigitsGrouping(value)
    }

    public get pop_up_plan_text() {
        const text = this.tr('pop_up_plan_text')
        return text
    }

    public tableCollapse = true
    public collapse(idx:number, collapse:boolean, collapseAll:boolean = false) {
        const el:ReportIPIPMRow = this.tableData[idx]
        if (el.hasChild) {
            for (const ch of this.tableData.slice(idx + 1)) {
                if (ch.parent_idx === idx) {
                    ch.visible = !collapse
                    if (collapse || collapseAll) {
                        this.collapse(ch['idx'], collapse, collapseAll)
                        ch.collapse = collapse
                    }
                }

            }
        }
        el.collapse = collapse
    }
    public collapseAll(collapse:boolean) {
        for (const item of this.tableData) {
            if (item.parent_idx === null && item.hasChild) {
                item.collapse = collapse
                this.collapse(item.idx, collapse, true)
            }
        }
        this.tableCollapse = collapse
    }
}
